import { Link } from "react-router-dom";
import { formatUrl } from "../utils/config";

const EstateCard = ({ estate }) => {
  if (!estate) return null;
  return (
    <div className="col-xl-4 col-md-6">
      <div className="estate-card h-100">
        <div className="estate-img">
          <img
            src={formatUrl(estate.thumbnail) || "/assets/img/estate-default.jpg"}
            alt={estate.name}
            onError={(e) => (e.currentTarget.src = "/assets/img/default-offer.png")}
          />
        </div>
        <div className="estate-content">
          <h4 className="estate-title">
            <h6>{estate.name}</h6>
            <p className="estate-type">{estate.type}</p>
          </h4>
          <p className="estate-location">
            <i className="fas fa-map-marker-alt"></i>{" "}
            {estate?.district || ""} {estate?.lga} {estate?.state}
          </p>
          <div className="mt-3">
            <Link
              to={`/estates/${estate.id}`}
              state={{ estate }}
              className="th-btn"
              style={{
                backgroundColor: "var(--theme-color)",
                color: "#fff",
                display: "inline-block",
                padding: "10px 18px",
                borderRadius: "4px",
                textDecoration: "none",
              }}
            >
              View Details <i className="fas fa-arrow-right ms-1" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstateCard;
